import { render, staticRenderFns } from "./crossReport.vue?vue&type=template&id=57db3e8c&scoped=true&"
import script from "./crossReport.vue?vue&type=script&lang=js&"
export * from "./crossReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db3e8c",
  null
  
)

component.options.__file = "crossReport.vue"
export default component.exports